module.exports = __webpack_public_path__ + "static/media/support-station-photo-01.2756f6fe.jpg";